
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66667 2H15.3333V5.33333H8.66667V2ZM17 3.66667H21.1667C21.6267 3.66667 22 4.04 22 4.5V19.5C22 19.915 21.695 20.2667 21.285 20.325L15.4517 21.1583C15.4125 21.1642 15.3725 21.1667 15.3333 21.1667C15.2342 21.1667 15.135 21.1492 15.04 21.1142L8.63167 18.71L3.06167 20.3017C2.81167 20.3725 2.54 20.3225 2.33083 20.1658C2.1225 20.0075 2 19.7608 2 19.5V4.5C2 4.04 2.37333 3.66667 2.83333 3.66667H7V6.16667C7 6.62667 7.37333 7 7.83333 7H16.1667C16.6267 7 17 6.62667 17 6.16667V3.66667ZM9.5 15.6783L10.6783 14.5L9.01167 12.8333L10.6783 11.1667L9.5 9.98833L7.24417 12.2442C6.91833 12.57 6.91833 13.0967 7.24417 13.4225L9.5 15.6783ZM14.5 15.6783L16.7558 13.4225C17.0817 13.0967 17.0817 12.57 16.7558 12.2442L14.5 9.98833L13.3217 11.1667L14.9883 12.8333L13.3217 14.5L14.5 15.6783Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowcodeFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
